import React from 'react'
import {
  Bar,
  BarChart,
  LabelList,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

import { SubscriptionStats } from '../../api/services/dd_panel_main_accounts/types.ts'

// Dodajemy dwa rodzaje procentów do chartData
const calculatePercentages = (data: SubscriptionStats[]) => {
  const totalPaidAmount = data.reduce((acc, item) => acc + item.paid_amount, 0)

  return data.map((item) => ({
    ...item,
    // % udział sumy opłat w ogólnej sumie
    paid_percent:
      totalPaidAmount > 0 ? (item.paid_amount / totalPaidAmount) * 100 : 0,
    // % opłaconych zamówień w stosunku do wszystkich zamówień (dla tego słupka)
    paid_orders_percent:
      item.orders_count > 0
        ? (item.orders_paid_count / item.orders_count) * 100
        : 0
  }))
}

// Label dla sumy opłat (słupek pomarańczowy)
const PercentLabelAmount = (props: any) => {
  const { x, y, width, height, value } = props
  return (
    <g>
      {value && (
        <text
          x={x + width / 2}
          y={y + height / 2}
          fill="#fff"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={12}
          fontWeight="bold"
        >
          {value.toFixed(0) + '%'}
        </text>
      )}
    </g>
  )
}

// Label dla opłaconych zamówień (słupek zielony)
const PercentLabelPaidOrders = (props: any) => {
  const { x, y, width, height, value } = props
  return (
    <g>
      {value && (
        <text
          x={x + width / 2}
          y={y + height / 2}
          fill="#fff"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={12}
          fontWeight="bold"
        >
          {value.toFixed(0) + '%'}
        </text>
      )}
    </g>
  )
}

export const GlobalStatisticsCharts = ({
  data
}: {
  data: SubscriptionStats[]
}) => {
  const chartData = calculatePercentages(data)

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData}>
        <XAxis
          dataKey="subscription_length"
          label={{
            value: 'Długość subskrypcji (miesiące)',
            position: 'insideBottom',
            offset: 5
          }}
        />
        {/* Lewa oś Y: ilość zamówień */}
        <YAxis
          dataKey={'orders_count'}
          allowDecimals={false}
          yAxisId="left"
          label={{
            value: 'Ilość zamówień',
            angle: -90,
            position: 'insideLeft'
          }}
        />
        {/* Prawa oś Y: suma opłat */}
        <YAxis
          dataKey={'paid_amount'}
          yAxisId="right"
          orientation="right"
          label={{
            value: 'Suma opłat (zł)',
            angle: 90,
            position: 'insideRight'
          }}
        />

        <Tooltip />
        <Legend />
        <Bar
          yAxisId="left"
          dataKey="orders_count"
          fill="#8884d8"
          name="Zamówień"
        />
        <Bar
          yAxisId="left"
          dataKey="orders_paid_count"
          fill="#82ca9d"
          name="Opłaconych"
        >
          <LabelList
            dataKey="paid_orders_percent"
            content={<PercentLabelPaidOrders />}
          />
        </Bar>
        <Bar
          yAxisId="right"
          dataKey="paid_amount"
          fill="#ff7300"
          name="Suma opłat"
        >
          <LabelList dataKey="paid_percent" content={<PercentLabelAmount />} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}
